import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { useApi } from "@/src/lib/hooks/api/use-api";
import Layout from "../layout";
import { AccountInfo, ProfileInfo } from "./components";

export default function Profile() {
	const { t } = useTranslation();
	const { auth, users } = useApi();
	const { data: session, refetch: refetchSession } = auth.useSession();
	const { data: userProfile } = users.getCurrentUserProfile();

	return (
		<Layout>
			<div className="p-4 md:p-8 border min-h-full rounded-large bg-gradient-main">
				<div className="max-w-4xl mx-auto">
					{/* Header */}
					<motion.div
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.25, ease: "easeOut" }}
						className="text-center mb-12"
					>
						<h1 className="text-3xl font-manrope font-semibold mb-2">
							{t("profile.header")}
						</h1>
						<p className="text-muted-foreground">{t("profile.subheader")}</p>
					</motion.div>

					<div className="space-y-8">
						<motion.div
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.25, delay: 0.05, ease: "easeOut" }}
						>
							<ProfileInfo
								session={session}
								userProfile={userProfile}
								onSessionUpdate={refetchSession}
							/>
						</motion.div>

						<motion.div
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.25, delay: 0.1, ease: "easeOut" }}
						>
							<AccountInfo
								session={session}
								userProfile={userProfile}
								onSessionUpdate={refetchSession}
							/>
						</motion.div>
					</div>
				</div>
			</div>
		</Layout>
	);
}
